
export default function displayNullableData(data){
    return data?
        data : 'Dado não cadastrado'
}
